import { render, staticRenderFns } from "./Geos.vue?vue&type=template&id=a10528aa&scoped=true&"
import script from "./Geos.vue?vue&type=script&lang=js&"
export * from "./Geos.vue?vue&type=script&lang=js&"
import style0 from "./Geos.vue?vue&type=style&index=0&id=a10528aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10528aa",
  null
  
)

export default component.exports